import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { RoleQuery as RoleQueryType, RoleQueryVariables } from "./__generated__/RoleQuery";

const RoleQuery = loader("./RoleQuery.gql");

type RoleQueryProviderType = (props: {
  children: (data: RoleQueryType) => ReactNode;
  variables: RoleQueryVariables;
}) => ReactElement;

export const RoleQueryProvider: RoleQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<RoleQueryType, RoleQueryVariables>(RoleQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
